export default __webpack_public_path__ + "static/media/mobileTitle.c15c2880.svg";